import React from 'react';
import { Image } from 'antd';
import { MessageQuestionIcon } from 'icons';

import { useAppDispatch } from 'store';

import { setQuestionId, setTestFeedbackModal } from 'modules/global';

interface IProps {
  title?: string;
  testImage?: string;
  questionId?: number;
}

const TopSection: React.FC<IProps> = ({ title, testImage, questionId }) => {
  const dispatch = useAppDispatch();

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(questionId as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <>
      <div className="flex items-center justify-end">
        <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
          <MessageQuestionIcon />
        </div>
      </div>
      <div className="transition-all duration-300">
        <div className="mt-1 font-medium">{title}</div>
        {testImage && (
          <div className="mt-4 flex justify-center">
            <Image src={testImage} alt={title} loading="lazy" className="!rounded-xl" title="Test image" />
          </div>
        )}
      </div>
    </>
  );
};

export default TopSection;
